'use client';
import Link from 'next/link';
import { ArrowLeft } from 'lucide-react';

export default function CareersPage() {
  return (
    <div className="min-h-screen bg-white text-[#0f172a]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <Link href="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#1a56ff] mb-8 transition-colors">
          <ArrowLeft size={16} /> Back to Home
        </Link>
        <h1 className="text-3xl sm:text-4xl font-bold mb-6">Careers at dropservice.in</h1>
        <div className="text-slate-600 space-y-5 text-sm leading-relaxed">
          <p>We are always looking for talented, passionate individuals to join our growing team. At dropservice.in, you will work on a product that directly impacts thousands of entrepreneurs across India.</p>
          <div className="bg-blue-50 rounded-2xl p-6 mt-8">
            <h2 className="text-base font-bold text-[#0f172a] mb-2">No open positions right now</h2>
            <p className="text-sm text-slate-500">We currently have no open positions, but we are always interested in hearing from talented people. Send your resume to <a href="mailto:support@dropservice.in" className="text-[#1a56ff] hover:underline">support@dropservice.in</a> and we will keep you in mind for future opportunities.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
